var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "case-share-detail" }, [
    _c(
      "div",
      { staticClass: "is-weiXin-tip hidden", class: { show: _vm.is_weixn() } },
      [
        _c("img", {
          staticClass: "tip-open",
          attrs: {
            src: require("@/assets/case-share-detail/what_tip.png"),
            alt: ""
          }
        })
      ]
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "box info" },
      [
        [1, 2].includes(_vm.detail.caseGrade)
          ? _c("img", {
              staticClass: "tag",
              attrs: {
                src: require("@/assets/case-share-detail/tag" +
                  _vm.detail.caseGrade +
                  ".png"),
                alt: "",
                srcset: ""
              }
            })
          : _vm._e(),
        _vm._l(_vm.detailArr, function(item, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isNull(_vm.detail[item.key]),
                  expression: "!isNull(detail[item.key])"
                }
              ],
              key: index + "detail",
              staticClass: "line"
            },
            [
              _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
              _c("p", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(
                    item.arr
                      ? _vm.caseDetailFilter(item.arr, _vm.detail[item.key])
                      : _vm.detail[item.key]
                  )
                )
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm.caseSourceV2ProblemList.length
      ? _c("div", { staticClass: "box info question" }, [
          _c("h3", [_vm._v("平台跟进信息")]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.caseSourceV2ProblemList, function(item, index) {
              return _c(
                "div",
                { key: index + "question", staticClass: "line" },
                [
                  _c("p", { staticClass: "que" }, [
                    _vm._v(_vm._s(item.problemInfo))
                  ]),
                  _c("p", { staticClass: "ans" }, [
                    _vm._v(_vm._s(_vm.filterAnswer(item, index)))
                  ])
                ]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "box progress" }, [
      _c("p", { staticClass: "title" }, [_vm._v("服务流程")]),
      _c(
        "div",
        { staticClass: "progress-content" },
        _vm._l(_vm.progressArr, function(item, index) {
          return _c("div", { key: index + "progress", staticClass: "item" }, [
            _c("div", { staticClass: "one" }, [
              _c("p", { staticClass: "circle" }, [_vm._v(_vm._s(index + 1))]),
              _c("p", { staticClass: "desc" }, [_vm._v(_vm._s(item) + " ")])
            ])
          ])
        }),
        0
      )
    ]),
    _c("div", { staticClass: "btn-box" }, [
      _c("p", { staticClass: "btn", on: { click: _vm.openApp } }, [
        _vm._v("立即前往APP")
      ]),
      _c("p", { staticClass: "desc" }, [
        _vm._v("您还没安装法临律师端APP？请点击 "),
        _c("span", { on: { click: _vm.buttonDownload } }, [_vm._v("立即下载")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-bc" }, [
      _c("img", {
        staticClass: "bc",
        attrs: {
          src: require("@/assets/case-share-detail/topBc.png"),
          alt: "",
          srcset: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }